<template lang="pug">
	.audio-tracker-insertion
		.button.flex-row.center.align-center(:title="$tCaption('Edit', '@actions')", @click="v => showInsertion()", v-if="!isUIHidden")
		Popup(v-if="popupVisible", ref="popup", :popupVisible="popupVisible", :width="1080", :height="620", @hiding="stop", :closeOnOutsideClick="false", @resize="onResize")
			InsertionDetails(
				v-if="popupVisible && insertion && insertionVisible",
				ref="details",
				:tracker="tracker",
				:track="track",
				slot="body",
				:item="insertion",
				:getSsml="getSsml",
				:creativeIabCategories="creativeIabCategories",
				:templateFields="templateFields",
				:allowKeyEditing="isTemplate",
				:readonly="readonly",
				:customContextMenuItems="customContextMenuItems",
				:editorHeight="editorHeight",
				@loadAudio="actionGenerateAudio",
				@stopAll="stop",
				@save="save",
				@cancel="cancel",
				@remove="() => cancel(true)",
				@update-tags="(tags, exclude) => $emit('update-tags', tags, exclude)",
				@reload-tracks="tracks => $emit('reload-tracks', tracks)",
				@create-template-field="(tf, cb) => $emit('create-template-field', tf, cb)",
				@toggle-fullscreen="$refs.popup.fullScreen = !$refs.popup.fullScreen"
			)
				template(v-for="(_, slot) of $scopedSlots" v-slot:[slot]="{ data }")
					slot(:name="slot" v-bind="data")
			Loader(v-if="!insertionVisible", :text="$tCaption('Loading', '@actions')", :fullscreen="true")
		Popup(v-if="geoTargetVisible", :popupVisible="geoTargetVisible", :width="1200", :height="540", :title="$tCaption('Geo targets')" :closeOnOutsideClick="false")
			.flex-row.space-large.audio-tracker-insertion--geo-target
				GeoTargetsList.full-width(ref="geoTargetList", :height="300", :geoTargetDrawings="geoTargetDrawings", :placeResolver="placeResolver",
					:insertionId="insertion.oid",
					:insertion="track.insertion",
					:linkedTargets="linkedTargets",
					@remove="onTargetRemove",
					@create="onNewTargetCreate")
					template(v-slot:target-header="{ target }")
						.include-button.ui-button.upper.hover.scale.align-center.center.flex-row(v-for="insertionTarget in [getInsertionTarget(target)]", v-if="insertionTarget",
							@click="toggleIncludeInsertionTarget(insertionTarget)",
							:class="{ exclude: insertionTarget.Exclude }") {{insertionTarget.Exclude ? $tCaption('exclude') : $tCaption('include')}}
			.right.flex-row.space(slot="actions-left")
				DxButton(v-if="geoTargetDrawings.length", :text="$tCaption('Reset', '@actions')", type="normal", icon="fas fa-redo", @click="resetGeoTarget", :disabled="!!isLoading")
			.right.flex-row.space(slot="actions-right")
				DxButton(:text="$tCaption('Save', '@actions')", type="success", icon="fas fa-check", @click="saveGeoTargets", :disabled="!geoTargetChanged || !!isLoading")
				DxButton(:text="$tCaption('Cancel', '@actions')", icon="fas fa-times", @click="geoTargetVisible = false")
</template>

<script>
	import Promise from 'bluebird';
	import InsertionDetails from '../insertion/Detail.vue';
	import Data from 'app-core/Data';
	import _ from 'lodash';
	import Popup from 'app-core/Popup.vue';
	import api from 'view/carto/api.js';
	import DxNumberBox from 'devextreme-vue/number-box';
	import DxCheckBox from 'devextreme-vue/check-box';
	import DxButton from 'devextreme-vue/button';
	import GeoTargetsList from 'view/insertion/GeoTargetsList.vue';
	import cognitiveArrays from 'view/insertion/cognitive-arrays';
	import ssmlHelper from 'view/insertion/ssml-helper.js';
	import axios from 'axios';
	import Loader from 'app-core/Loader.vue';

	export default {
		translationCategory: 'audioTracker.AudioTrackerInsertion',
		name: 'audio-tracker-insertion',
		components: {Popup, InsertionDetails, DxNumberBox, DxButton, DxCheckBox, GeoTargetsList, Loader},
		props: ['track', 'width', 'isUIHidden', 'tracker', 'creativeIabCategories', 'templateFields', 'isTemplate', 'readonly', 'customContextMenuItems'],
		mixins: [cognitiveArrays],
		data() {
			return {
				popupVisible: false,
				geoTargetVisible: false,
				geoTargetRadius: 3,
				geoTargetDrawings: [],
				geoTargetChanged: false,
				fileData: null,
				audioPlayer: null,
				isLoading: 0,
				insertion: null,
				wasPlayInitialized: false,
				creatingNewGeoTarget: false,
				selectedGeoTargetPlace: null,
				linkedTargets: [],
				insertionVisible: false,
				editorHeight: null
			};
		},
		computed: {
			radiusFormat() {
				return `${this.$tCaption('Radius')}: #0 ${api.kmOrMiles()}`;
			}
		},
		watch: {
			srcAudio() {
				this.emitChange();
			},
			'insertion.isPlaying'(v) {
				if (!v)
					this.stop();
			},
			'track'() {
				this.setInsertion();
			},
			'track.__isLoading'(v) {
				if (__DEBUG__)
					console.debug('Emit loading');
				this.$emit('track-loading', v);
			},
			'insertion.EventRule.Oid'(v) {
				this.$emit('on-event-rule-changed', this.track, this.insertion);
			},
			'popupVisible'(v) {
				if (v) {
					this.wasPlayInitialized = false;
					this.insertionVisible = false;
					setImmediate(() => this.insertionVisible = true);
				}
				this.$emit('popup', v);
			},
			geoTargetVisible(v) {
				this.$emit('popup', v);
			},
			'track.insertion'() {
				this.setInsertion();
			},
		},
		mounted() {
			if (__DEBUG__) {
				window.insertion = this;
				console.debug('Open dialog', this.track?.openDialog, this.parentId);
			}
			this.setInsertion();
			this.showDialog(!!this.track?.openDialog);
		},
		destroyed() {
		},
		methods: {
			onResize(w,h) {
				this.editorHeight = Math.max(200, h - 280);
			},
			showDialog(v) {
				this.popupVisible = false;
				if (v)
					setImmediate(() => {
						if (this._isDestroyed) return;
						this.popupVisible = true;
					});
			},
			getLanguage(val) {
				let language = val
				if (language && language.indexOf('-') === -1) {
					language = `${language.slice(0,2)}-${language.slice(2,4)}`;
				}
				return language;
			},
			getInsertionTarget(target) {
				return _.find(this.linkedTargets, v => v.LinkedTarget.Oid === target.Oid);
			},
			placeResolver(target) {
				return { ...this.getGeoTargetStyle(target), include: true };
			},
			onNewTargetCreate(target) {
				if (_.find(this.linkedTargets, v => v.LinkedTarget?.Oid === target.Oid)) return;
				this.linkedTargets.push({ Exclude: false, LinkedTarget: target, added: true });
				this.buildGeoTargetDrawings();
				this.geoTargetChanged = true;
			},
			onTargetRemove(target) {
				if (__DEBUG__)
					console.debug('On target remove', { target });
				_.remove(this.linkedTargets, v => v?.LinkedTarget?.Oid === target?.Oid);
				this.geoTargetChanged = true;
			},
			toggleIncludeInsertionTarget(insertionTarget) {
				insertionTarget.Exclude = !insertionTarget.Exclude;
				this.geoTargetChanged = true;
				this.buildGeoTargetDrawings();
			},
			resetGeoTarget() {
				this.geoTargetChanged = true;
				this.linkedTargets = [];
				this.buildGeoTargetDrawings();
			},
			async saveGeoTargets() {
				let track = this.track;
				let baseTargets = (track.insertion.Targets || []).map(f => ({ ...f, LinkedTarget: f.LinkedTarget }));
				let changedOrNew = this.linkedTargets.filter(f => {
					let exists = baseTargets.filter(e => e.LinkedTarget.Oid === f.LinkedTarget.Oid)[0];
					return !exists || !_.isEqual(exists, f);
				});
				let removed = baseTargets.filter(e => !this.linkedTargets.some(f => f.LinkedTarget.Oid === e.LinkedTarget.Oid));

				this.isLoading++;
				try {
					if (changedOrNew.length)
						await this.$Data.postExternalApi('Target/LinkTarget', changedOrNew.map(f => ({ ...f, ObjectId: this.track.id })));

					if (removed.length)
						await this.$Data.postExternalApi('Target/UnlinkTarget', removed.map(f => ({ ...f, ObjectId: this.track.id })));

					this.geoTargetVisible = false;
					track.insertion.Targets = this.linkedTargets;

					this.$notifySuccess(this.$tCaption('Data saved', '@actions'));
				} finally {
					this.isLoading--;
				}

				if (__DEBUG__)
					console.debug('Save geo targets', { changedOrNew, removed });

				this.$emit('save');
			},
			getGeoTargetStyle(target, insertion) {
				return { ...target, color: (insertion || target).Exclude ? '#b4b4b4' : '#f27649', include: !(insertion || target).Exclude };
			},
			buildGeoTargetDrawings() {
				this.geoTargetDrawings = [];
				if (this.linkedTargets)
					this.geoTargetDrawings = this.linkedTargets.map(f => ({ ...Data.formatObjectToLowerCase(this.getGeoTargetStyle(f.LinkedTarget, f)), include: !f.Exclude, name: f.Name }));
			},
			showGeoTarget() {
				this.geoTargetVisible = false;
				this.geoTargetChanged = false;
				setImmediate(() => {
					if (this._isDestroyed) return;
					this.linkedTargets = _.cloneDeep(this.track.insertion.Targets) || [];
					this.creatingNewGeoTarget = false;
					this.buildGeoTargetDrawings();
					this.geoTargetVisible = true;
				});
			},
			setInsertion() {
				if (!this.track) return;
				let insertion = Data.formatObjectToLowerCase(this.track.insertion);
				this.insertion = {
					...insertion,
					subInsertions: this.track.insertion.SubInsertions && this.track.insertion.SubInsertions.map(f => Data.formatObjectToLowerCase(f)) || [],
					buffer: this.tracker.tracksBuffers[this.track.id],
					base64: this.tracker.tracksBase64[this.track.id],
				};

				if (this.track?.openDialog && !this.popupVisible) {
					this.showDialog(true);
				}
			},
			showInsertion() {
				this.popupVisible = false;
				setImmediate(() => {
					if (this._isDestroyed) return;
					this.setInsertion();
					this.popupVisible = true;
				});
			},
			actionGenerateAudio(record, promiseCallback, options) {
				let promise = this.generateAudio(record, options);
				if (promiseCallback)
					promiseCallback(promise);
			},
			getSsml(record, ssml, isPreview) {
				if (__DEBUG__)
					console.debug('Get ssml', { record, ssml });
				if (!ssml) return null;

				let data = ssmlHelper.prepareSsml(ssml, { ...record, sender: this, isPreview });

				return isPreview ? data : data?.ssml;
			},
			async generateAudio(record, options) {
				if (__DEBUG__)
					console.debug('Generate audio');
				this.wasPlayInitialized = true;
				this.isLoading++;
				record = record || this.insertion;

				let selectedVoice = this.findVoice(record.voice, record.language);
				if (selectedVoice?.isCustom) {
					if (!await this.getIsCustomVoiceActive(selectedVoice?.voice?.Oid, record.voiceStyle)) {
						selectedVoice.isActive = false;
					}
				}

				let previewSsml = this.getSsml(record, (options && options.ssml) || record.pureSSML || record.ssml || record.text, true);
				record.hasDefaultVoiceReplaced = previewSsml?.hasDefaultVoiceReplaced;
				record.defaultVoiceName = previewSsml?.voice;

				if (__DEBUG__)
					console.debug('Preview ssml', previewSsml);

				let ssml = previewSsml?.ssml;

				if (__DEBUG__)
					console.log('Generate audio', { record, ssml, last: record.requestHashKey, options, previewSsml });

				let requestHashKey = `${ssml}_${JSON.stringify(record.voiceSettings || {})}`;

				if (ssml) {
					if (record.requestHashKey === requestHashKey && record.buffer)
						return Promise.resolve({
							buffer: record.buffer,
							base64: record.base64,
							record
						}).finally(() => this.isLoading--);
					let loadParams = {
						Language: record.language,
						Voice: previewSsml.voice,
						VoiceStyle: record.voiceStyle,
						Rate: record.rate,
						Pitch: record.pitch,
						Ssml: ssml,
						Oid: record.oid,
						ParentId: record.parentId,
						CreativeId: record.creativeId,
						TtsProviderType: record.ttsProviderType,
						ClientProcessId: this.$auth.getGlobalProcessId(),
						VoiceSettings: record.voiceSettings
					};

					return new Promise((resolve, reject) => {
						Data.postExternalApi('Creative/BuildAudioCustom', loadParams)
							.then(data => {
								if (__DEBUG__)
									console.info('Get audio data response', { data });
								if (this._isDestroyed) return;

								if (data?.ErrorMessage) {
									reject(null);
									return null;
								} else {
									if (this._isDestroyed) return;

									let base64 = `data:audio;base64,${data?.AudioData}`;
									this.fileData = base64;

									axios
										.get(base64, {
											responseType: 'blob'
										})
										.then(r => {
											r.data.arrayBuffer()
												.then(arrayBuffer => {
													if (__DEBUG__) {
														console.debug('GenerateAudio load buffer', {
															arrayBuffer,
															length: arrayBuffer.length,
															tracker: this.tracker
														});
														window.response = arrayBuffer;
													}
													if (arrayBuffer.length === 0) {
														reject('Empty ssml');
														return;
													}

													this.tracker.audioContext.decodeAudioData(arrayBuffer, (buffer) => {
														if (__DEBUG__)
															console.debug('Generate audio decoded', { buffer });
														record.buffer = buffer;
														record.base64 = base64;
														record.dynamicSsmlResult = data?.SsmlInsertion?.DynamicSsmlResult;
														record.rate = data?.SsmlInsertion?.Rate || 1;
														record.requestHashKey = requestHashKey;
														record.lastTtsLogId = data?.TtsLog?.Oid || record.lastTtsLogId;

														resolve({ buffer, base64, record });
													});
												});
										});
								}
							})
							.catch(ex => {
								if (__DEBUG__)
									console.debug('Get speech exception', { ex });
								reject(ex);
							});
					}).finally(() => this.isLoading = 0);
				} else {
					this.isLoading = 0;
					throw Error('Empty ssml');
				}
			},
			saveInsertion(track, insertion, isNew) {
				isNew = isNew === true || !insertion.oid;
				if (__DEBUG__)
					console.debug('Save insertion');
				return Data.createUpdateInsertion(insertion).then(r => {
					if (__DEBUG__)
						console.info('Insertion created/updated', r);
					if (r.Success) {
						if (isNew)
							insertion.oid = r.Data.Oid;
						if (r.Data.EventRule) {
							insertion.eventRuleName = r.Data.EventRule.Name;
						}
						_.assign(track.insertion, r.Data);
					} else {
						this.$notifyError(r.ErrorMessage);
					}

					this.$emit('save');
					return r.Data;
				});
			},
			async updateInsertionSSML(track, insertion, isNew) {
				if (!track || !insertion) return;
				track.__isLoading++;
				if (__DEBUG__)
					console.debug('Update insertion SSML', { track, insertion });
				let generateInsertion = this.$Data.formatObjectToLowerCase(insertion);
				await this.generateAudio(generateInsertion).then((res) => {
					let buffer = res.buffer;
					let base64 = res.base64;
					if (__DEBUG__)
						console.debug('Update insertion SSML data generated', { buffer, base64, dur: buffer.duration, generateInsertion });
					if (base64) {
						insertion.JsonConfig.hasDefaultVoiceReplaced = generateInsertion.hasDefaultVoiceReplaced;
						if (insertion.JsonConfig.hasDefaultVoiceReplaced) {
							insertion.JsonConfig.defaultVoiceName = generateInsertion.defaultVoiceName;
						}
						let data = base64;
						track.__isLoading++;
						this.$emit('set-track', {
							insertion: insertion,
							track: track,
							trackId: track.id,
							buffer: buffer,
							base64: base64,
							isNew
						});
						return this.$azure.uploadInsertionAudio(insertion, data)
							.then(audio => {
								if (__DEBUG__)
									console.debug('SSML insertion uploaded', { audio, trackId: track.id, track });
								track.insertion.Audio = audio;
								this.$emit('save');
							})
							.catch((ex) => {
								console.error(ex);
								this.$notifyError(ex);
							})
							.finally(() => track.__isLoading--)
					}
				}).finally(() => track.__isLoading--);
			},
			async save(record, preventClose, preventUploadAudio) {
				this.isLoading++;
				let pureSSML = record && record.pureSSML;
				if (record)
					delete record.pureSSML;

				let hasGlobalDataChanged = this.insertion.voice !== record.voice;
				if (hasGlobalDataChanged && this.track.type === 'textToSpeech') {
					if (__DEBUG__)
						console.debug('SSML hasGlobalDataChanged');
					this.tracker.getAggregatedTrackItems(this.track?.__aggregatedTrack?.trackNumber || 0, true).filter(f => f.id !== this.track.id && f.type === 'textToSpeech').map(async track => {
						if (track.insertion.Voice !== record.voice || track.insertion.Language !== record.language) {
							if (track.insertion.Voice !== record.voice) {
								track.insertion.StartOffset = 0;
								track.insertion.EndOffset = 0;
							}
							track.insertion.Voice = record.voice;
							track.insertion.Language = record.language;
							track.insertion.Ssml = this.getSsml(this.$Data.formatObjectToLowerCase(track.insertion), track.insertion.Ssml);
							await this.updateInsertionSSML(track, track.insertion);

							track.__isLoading++;
							if (__DEBUG__)
								console.debug('Save');
							Data.createUpdatePureInsertion(track.insertion).finally(() => track.__isLoading--);
						}
					});
				}

				if (this.insertion.voice && this.insertion.voice !== record.voice) {
					record.startOffset = 0;
					record.endOffset = 0;
				}

				let track = this.track;
				let insertion = this.insertion;
				let originalSsml = track.insertion?.Ssml;
				let isNew = !insertion.oid;

				record.startTime = this.track?.insertion?.StartTime || record.startTime;
				record.endOffset = this.track?.insertion?.EndOffset || record.endOffset;
				record.startOffset = this.track?.insertion?.StartOffset || record.startOffset;

				_.assign(this.insertion, record);

				this.insertion.isNew = false;
				if (pureSSML && this.getSsml(this.insertion, this.insertion.ssml) !== pureSSML) {
					this.insertion.ssml = pureSSML;
				} else {
					this.insertion.ssml = this.getSsml(this.insertion, this.insertion.ssml);
				}
				if (__DEBUG__)
					console.info('Save insertion data', { record, ins: this.insertion, pureSSML });

				if (track) {
					track.insertion = this.$Data.formatObjectToUpperCase(insertion);
				}

				if (!preventClose)
					this.popupVisible = false;
				setImmediate(() => this.$forceUpdate());

				track.__isLoading++;

				if (!track.id) {
					track.id = this.$Data.uuid();
					this.$emit('set-track', {
						insertion: {
							...this.$Data.formatObjectToUpperCase(insertion),
							Oid: track.id,
							Duration: 2000
						},
						track,
						trackId: track.id,
						buffer: null,
						base64: null,
						isNew: true
					});
					track.__isInsertionLoaded = false;
				}
				this.$emit('loading', 1);

				let savedInsertion = null;
				let saveIns = async () => {
					if (!savedInsertion) {
						insertion.jsonConfig.hasDefaultVoiceReplaced = insertion.hasDefaultVoiceReplaced;
						if (insertion.hasDefaultVoiceReplaced) {
							insertion.jsonConfig.defaultVoiceName = insertion.defaultVoiceName;
						}
						savedInsertion = await this.saveInsertion(track, insertion, isNew);
						let upperInsertion = this.$Data.formatObjectToUpperCase(insertion);
						upperInsertion.SubInsertions = upperInsertion.SubInsertions && upperInsertion.SubInsertions.map(f => Data.formatObjectToUpperCase(f)) || [];
						if (isNew) {
							track.id = insertion.oid;
							track.__isInsertionLoaded = true;
						}
					}
					return savedInsertion;
				}

				let previewSsml = this.getSsml(insertion, insertion.ssml, true);
				insertion.hasDefaultVoiceReplaced = previewSsml?.hasDefaultVoiceReplaced;
				insertion.defaultVoiceName = previewSsml?.voice;

				if (insertion.hasDefaultVoiceReplaced) {
					await saveIns();
				}

				return this.generateAudio(insertion).then((res) => {
					let buffer = res.buffer;
					let base64 = res.base64;
					this.isLoading++;
					insertion.jsonConfig.hasDefaultVoiceReplaced = insertion.hasDefaultVoiceReplaced;
					if (insertion.hasDefaultVoiceReplaced) {
						insertion.jsonConfig.defaultVoiceName = insertion.defaultVoiceName;
					}
					return saveIns().then((savedInsertion) => {
						if (__DEBUG__)
							console.info('Insertion audio generated', { ins: insertion, preventUploadAudio });
						const trackId = track && track.id || insertion.oid;

						if (base64 && !preventUploadAudio) {
							let data = base64;
							return this.$azure.uploadInsertionAudio(savedInsertion, data)
								.then(audio => {
									if (__DEBUG__)
										console.debug('SSML insertion uploaded', { audio, trackId, track });
									this.tracker.setBuffer(trackId, buffer, base64);
									this.$emit('set-track', {
										track,
										insertion: {
											...this.$Data.formatObjectToUpperCase(insertion),
											Audio: audio
										}
									});
								})
								.catch((ex) => {
									throw(ex);
								})
								.finally(() =>  {
									this.isLoading = false;
									track.__isLoading--;
									track.__preventLinksProcessing = false;
								});
						} else {
							this.isLoading = 0;
							track.__isLoading--;
						}
						return savedInsertion;
					}).catch((ex) => {
						throw(ex);
					});
				}).catch((ex) => {
					if (__DEBUG__)
						console.debug('Saving insertion error');
					this.isLoading = 0;
					track.__isLoading--;
					if (!savedInsertion && isNew) {
						this.$emit('delete-track', track, true);
					}
					if (!isNew && !savedInsertion) {
						track.insertion.Ssml = originalSsml;
					}
				}).finally(() => this.$emit('loading', -1));
			},
			cancel(remove) {
				if (remove && !this.insertion.isNew) {
					this.$emit('remove', this.track);
				}

				this.popupVisible = false;
			},
			stop() {
				if (this.tracker && this.wasPlayInitialized)
					this.tracker.stop();
			},
		}
	};
</script>

<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.audio-tracker-insertion--geo-target {
		height: 360px;

		.targets-list {
			width: 380px;
		}

		.target-name {
			max-width: 220px;

			&.exclude {
				text-decoration: line-through;
			}
		}

		.include-button {
			font-size: 10px;
		}
	}
</style>
